import { takeEvery, call, put } from 'redux-saga/effects';
import { yaGoal } from 'mt-react-common/utils/Analytics';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';

import {
  sendRequest,
  requestFinished as createTaskExecFinished,
  requestInProcess as createTaskExecRequestInProcess
} from '../../../../common/reducers/execCreateForm';
import TasksExecsService from '../../../../services/TasksExecsService';
import { dataRequest } from '../../../../../../common/reducers/objectCollection/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';

function* execCreateFormSaga(reducerName, action) {
  yield put(createTaskExecRequestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      TasksExecsService.createTaskExec,
      action.payload
    );
    if (result.status === 201) {
      yield put(sendGetAuthAccountDataRequest());
      yield put(
        dataRequest('tasksModule.collections.tasksCollection', action.payload)
      );
      yaGoal('createTaskExec');
    } else if (result.status === 422) {
      yield put(
        clientNoticesActions.addClientNotice({
          type: 'danger',
          message: result.data[0].message
        })
      );
    }
    yield put(
      createTaskExecFinished(reducerName, result.status, result.status === 201)
    );
  } catch (error) {
    yield put(createTaskExecFinished(reducerName));
  }
}

export default function createSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, execCreateFormSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/forms/sagas/execCreateFormSaga.js